import { JSONObject } from '../../../types/types';

export const normalizeFormDataToCompare = (
  json: JSONObject,
  expectedKeys: string[] = []
) => {
  const result: Record<string, unknown> = {};

  // Seed declared form-item keys with null so absent-vs-empty compares equal.
  expectedKeys.forEach((key) => {
    const value = json[key];

    if (value === '' || value === undefined) {
      result[key] = null;
      return;
    }

    if (value !== null && !isNaN(Number(value))) {
      result[key] = Number(value);
      return;
    }

    result[key] = value;
  });

  return result;
};
